<template>
    <div
        role="button"
        tabindex="0"
        class="p-4 rounded-xl flex items-center gap-4 border cursor-pointer transition-colors hover:border-control-border-strong text-ink"
        :class="[selected ? 'border-control-accent bg-toggle-option-selected' : 'border-border-strong bg-surface-raised']"
        :aria-pressed="selected"
        @click="$emit('toggle')"
        @keydown.enter="$emit('toggle')"
        @keydown.space.prevent="$emit('toggle')">
        <BaseCheckbox :model-value="selected" class="shrink-0" @click.stop @update:model-value="$emit('toggle')" />

        <div class="flex items-center gap-3 grow min-w-0">
            <CalendarAttendeeAvatar size="md" :name="person.name" :email="person.email" />

            <div class="flex flex-col gap-1 min-w-0 grow">
                <div class="flex items-center gap-2 flex-wrap">
                    <span class="body-small-semibold truncate">{{ person.name }}</span>
                    <BaseChip v-if="person.has_public_profile" size="2xs" class="whitespace-normal">
                        <i class="bi text-[10px]" :class="COLLABORATION_PROFILE_BOOTSTRAP_ICON_CLASS" aria-hidden="true"></i>
                        {{ t("connections.calendarImport.card.publicProfile") }}
                    </BaseChip>
                    <BaseChip v-else size="2xs" class="whitespace-normal">
                        <i class="bi bi-lock text-[10px]" aria-hidden="true"></i>
                        {{ t("connections.calendarImport.card.noProfile") }}
                    </BaseChip>
                </div>
                <div class="flex items-center gap-2 text-ink-muted">
                    <span v-if="person.title" class="body-small truncate">{{ person.title }}</span>
                    <span v-else class="body-small truncate">{{ person.email }}</span>
                </div>
            </div>
        </div>

        <div class="shrink-0">
            <span class="body-small-semibold text-ink-muted">{{ t("connections.calendarImport.card.meetingCount", { count: person.meeting_count }, person.meeting_count) }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseChip from "~vue/components/BaseChip.vue";
import CalendarAttendeeAvatar from "~vue/components/CalendarAttendeeAvatar.vue";
import BaseCheckbox from "~vue/components/form/BaseCheckbox.vue";
import { COLLABORATION_PROFILE_BOOTSTRAP_ICON_CLASS } from "~vue/components/navigation/menuPanes";
import type { CalendarPerson } from "~vue/types/connection";
import { useI18n } from "vue-i18n";

defineProps<{
    person: CalendarPerson;
    selected: boolean;
}>();

defineEmits<{
    toggle: [];
}>();

const { t } = useI18n();
</script>
